'use strict';

export default class RichTextEditorNewDirective {
    constructor($rootScope, $injector, $, $window, $bridges, $translate, $config, BridgeRuntimeService,
        InactivityTimeoutService, IAAPreferencesService, TaskCountdownService, $timeout, dialogs, $signals, TaskSelectionService,
        TelemetryBeaconService) {
        this.$rootScope = $rootScope;
        this.$injector = $injector;
        this.$ = $;
        this.$window = $window;
        this.$bridges = $bridges;
        this.$translate = $translate;
        this.$config = $config;
        this.BridgeRuntimeService = BridgeRuntimeService;
        this.InactivityTimeoutService = InactivityTimeoutService;
        this.IAAPreferencesService = IAAPreferencesService;
        this.TaskCountdownService = TaskCountdownService;
        this.$timeout = $timeout;
        this.dialogs = dialogs;
        this.$signals = $signals;
        this.TaskSelectionService = TaskSelectionService;
        this.TelemetryBeaconService = TelemetryBeaconService;
    }

    getDirective() {
        return {
            restrict: 'EA',
            replace: true,
            scope: {
                'change': '&',
                "contentObject": "=",
                "ngReady": "&",
                "disabled": "@",
                "restrictedEditingMode": "@",
                "placeholder": "@",
                "writingDirection": "=",
                "height": "@",
                "wordcount": "@",
                "textObject": "@",
            },
            template: '<rich-text-editor-ck5 richtexteditor="true"></rich-text-editor-ck5>',
            link: (scope, element, attrs, controller) => this.link(scope, element, attrs, controller)
        };
    }

    link(scope, element, attrs, controller) {
        // this._logIdentifier = 'TextObjectDirective5';
        scope.editorId = attrs.id;
        scope.ckEditorInstances = {};

        function getAttributeValueOrDefault(attribute, defaultValue) {
            return typeof attribute !== 'undefined' ? attribute : defaultValue;
        }

        function getPreferenceOrDefault(preferenceName, defaultValue) {
            var preferenceValue = scope.contentObject.getPreferences()[preferenceName];
            return typeof preferenceValue !== 'undefined' ? preferenceValue : defaultValue;
        }

        var editorElement = element.find(scope.editorId).context,
            restrictedEditingMode = getPreferenceOrDefault('restrictedEditingMode', getAttributeValueOrDefault(attrs.restrictedEditingMode, false)),
            placeholder = getPreferenceOrDefault('placeholder', getAttributeValueOrDefault(attrs.placeholder, null)),
            dataLang = getPreferenceOrDefault('lang', getAttributeValueOrDefault(attrs.lang, null)),
            enabledTools = getPreferenceOrDefault('enabledTools', getAttributeValueOrDefault(attrs.enabledTools, [])),
            height = getPreferenceOrDefault('height', getAttributeValueOrDefault(attrs.height, '300px')),
            wordcount = getPreferenceOrDefault('wordcount', getAttributeValueOrDefault(attrs.wordcount, false)),
            showToolbar = getPreferenceOrDefault('showToolbar', getAttributeValueOrDefault(attrs.showToolbar, 'true')),
            TaskInfoService = this.$injector.get('TaskInfoService'),
            TaskDataService = this.$injector.get('TaskDataService'),
            taskInfo = TaskInfoService.getTaskInfo(),
            writingDirection = taskInfo.getInputLanguage().writingDirection === 'rtl' ? true : false,
            textObject = getPreferenceOrDefault('textObject', getAttributeValueOrDefault(attrs.textObject, null));
        const telemetryBeaconService = this.TelemetryBeaconService;

        scope.dataLang = taskInfo.getISOInputLanguageCode();

        scope.isCMS = this.$rootScope.isCMS && !this.$rootScope.isPreview;
        scope.isCMSandPreview = this.$rootScope.isCMS || this.$rootScope.isPreview;
        scope.isPdf = this.$config.isPDFMode();

        if (enabledTools !== null) {
            var pluginNames = enabledTools.map(tool => {
                if (tool.id === 'tool_seperator') {
                    return '|';
                } else {
                    return tool.name;
                }
            });
        }

        const getMediaURL = (mediaObject, failed) => {
            var thumbnailSlug = '_thumb',
                thumbnailExtension = 'jpg';

            if (!angular.isObject(mediaObject)) {
                return false;
            }

            const taskuuid = this.TaskSelectionService.getTaskUUID();
            var thumbnail = angular.isDefined(thumbnail) ? thumbnail : false,
                re = /(?:\.([^.]+))?$/,
                uploadName = mediaObject.getUploadName(),
                extension = thumbnail ? thumbnailExtension : re.exec(uploadName)[1],
                mimeType = mediaObject.getMimeType(),
                fileNameSlug = thumbnail ? thumbnailSlug : "",
                fileName = mediaObject.getUUID() + fileNameSlug + '.' + extension,
                url;


            if (mimeType == 'image/svg+xml') {
                filename = mediaObject.getUUID() + fileNameSlug + '.svg';
            }

            url = scope.isCMSandPreview ? "/media/" + taskuuid + "/" + fileName : "/media/" + fileName;

            return url;
        };

        function adjustImageSrc(htmlContent) {
            var imgRegex = /<img[^>]*src="\/media\/[a-f0-9-]+\/([a-f0-9-]+\.(?:png|jpg|jpeg|gif))"[^>]*>/gi;
            var matches = htmlContent.matchAll(imgRegex);

            for (const match of matches) {
                var originalTag = match[0];
                var originalSrc = match[0].match(/src="([^"]*)"/)[1];
                var filename = originalSrc.split('/').pop();
                var newSrc = "/media/" + filename;
                var newTag = originalTag.replace(originalSrc, newSrc);
                htmlContent = htmlContent.replace(originalTag, newTag);
            }

            return htmlContent;
        }

        var SIGNAL_INPUT_SAVE = "response-save-input",
            SIGNAL_CKEDITOR_REGISTER = "register-save-ckeditor",
            INPUT_AUTOSAVE_KEYUP_DELAY = 2000;

        var mediaSelectedCk5Handler = (data, editor) => {
            if (scope.contentObject.getUUID() === data.contentobjectuuid) {
                var mediaObject = TaskDataService.fetchContext().read(data.uuid);
                if (mediaObject) {
                    editor.execute('insertImage', { source: getMediaURL(mediaObject, false) });
                }
            }
        };
        this.$signals.on('mediaSelected_ck5', mediaSelectedCk5Handler);

        let editor;

        scope.$on('$destroy', () => {
            this.$signals.remove('mediaSelected_ck5', mediaSelectedCk5Handler);
            const needToDestroyGlobalEditor = window.editor !== editor;
            if (editor) {
                try {
                    console.log("Destroying CKE", editor);
                    editor.destroy();
                    editor = null;
                } catch (e) {
                    console.warn('Error destroying editor:', e);
                }
            }
            // Clean up global editor if it exists
            if (window.editor) {
                try {
                    if (needToDestroyGlobalEditor) {
                        window.editor.destroy();
                    }
                    window.editor = null;
                } catch (e) {
                    console.warn('Error destroying window.editor:', e);
                }
            }
        });

        var setEditorListener = function (editor) {

            console.log("Setting up", element);
            const setEditorContent = (content) => {
                const editorId = scope.contentObject.getUUID() + '_ck5';
                const attachement = scope.contentObject.getAttachement();

                if (typeof attachement === 'object') {
                    attachement[editorId] = content;
                } else {
                    scope.contentObject.setAttachement({
                        [editorId]: content
                    });
                }
            };

            var onCkeditorChange = function (ev) {
                var value = editor.getData();
                scope.contentObject.setContent(editor.getData());
                const newContent = editor.getData();
                setEditorContent(newContent);
            };

            // -- Emitter for SIGNAL_INPUT_SAVE --
            var emitter = function () {
                console.log("handleEditorChange ==>");
                scope.$emit(SIGNAL_INPUT_SAVE);
            };

            var handleEditorChange = (function () {
                var timeout;
                return function () {
                    clearTimeout(timeout);
                    timeout = setTimeout(function () {
                        emitter();
                    }, INPUT_AUTOSAVE_KEYUP_DELAY);
                };
            })();

            editor.model.document.on('change:data', (ev) => {
                scope.isCMS ? onCkeditorChange(ev) : handleEditorChange();
            });
            scope.$emit(SIGNAL_CKEDITOR_REGISTER, editor);
        };

        async function reloadEditor(config) {
            if (editorElement && document.body.contains(editorElement)) {
                try {
                    const editor = await ClassicEditor.create(editorElement, config);
                    window.editor = editor;

                    const getSavedContent = () => {
                        const attachment = scope.contentObject.getAttachement();
                        const content = scope.contentObject.getContent();

                        if (!attachment && !content) {
                            return '';
                        }

                        const getTrimmedString = (value) => {
                            if (typeof value === 'string' && value.trim() !== '') {
                                return value.trim();
                            }
                            if (typeof value === 'object') {
                                for (let key in value) {
                                    if (value.hasOwnProperty(key) && typeof value[key] === 'string' && value[key].trim() !== '') {
                                        return value[key].trim();
                                    }
                                }
                            }
                            return '';
                        };

                        return getTrimmedString(attachment) || getTrimmedString(content);
                    };


                    scope.ckEditorInstances[scope.contentObject.getUUID()] = editor;
                    const savedContent = getSavedContent();

                    await new Promise(resolve => {
                        if (editor.state === "ready") {
                            resolve();
                        } else {
                            editor.on('ready', resolve);
                        }
                    });

                    setEditorListener(editor);
                    if (scope.isCMSandPreview && savedContent) {
                        editor.setData(savedContent);
                    } else if (savedContent) {
                        editor.setData(adjustImageSrc(savedContent));
                    }

                    var toolbarElement = editor.ui.view.toolbar.element;

                    if (!scope.isCMS) {
                        if (!showToolbar) {
                            toolbarElement.style.display = 'none';
                        } else {
                            toolbarElement.style.display = 'flex';
                        }
                    }

                    editor.editing.view.change(writer => {
                        var heightOptionToPixels = {
                            'extra small': 75,
                            'small': 150,
                            'medium': 300,
                            'large': 450
                        };
                        var heightInPixels = heightOptionToPixels[height] + 'px';

                        writer.setStyle('min-height', heightInPixels, editor.editing.view.document.getRoot());
                        writer.setAttribute('spellcheck', 'false', editor.editing.view.document.getRoot());
                        if (dataLang && dataLang === 'ur_UR') {
                            writer.addClass('urdu-font-force', editor.editing.view.document.getRoot());
                        }
                    });

                    if (wordcount && !scope.isCMS) {
                        const wordCountPlugin = editor.plugins.get('WordCount');
                        const wordCountID = scope.editorId.replace('_ck5', '_wordcount');
                        const wordCountWrapper = document.getElementById(wordCountID);
                        if (wordCountWrapper) {
                            wordCountWrapper.appendChild(wordCountPlugin.wordCountContainer);
                        }
                    }

                    return editor;
                } catch (error) {
                    console.error("Error creating editor:", error);
                    // Telemetry
                    try {
                        if (telemetryBeaconService && telemetryBeaconService.record) {
                            telemetryBeaconService.record('editor.create_failed', 'critical', {
                                errorMessage: error instanceof Error ? error.message.substring(0, 200) : String(error).substring(0, 200),
                                contentObjectUUID: scope.contentObject ? scope.contentObject.getUUID() : 'unknown',
                            });
                        }
                    } catch (telemetryError) {
                    }
                    throw error;
                }
            } else {
                console.warn("Editor element not found in the DOM");
                return null;
            }
        }

        async function startStandardEditingMode() {
            const config = {
                spellCheck: false,
                placeholder: placeholder,
                toolbar: {
                    items: pluginNames,
                    shouldNotGroupWhenFull: true
                },
                removePlugins: ['RestrictedEditingMode'],
                updateSourceElementOnDestroy: true,
                licenseKey: 'OWIvcXBqSmdzOTkzcnVmdjJMV2k2M2JFR1ovM3czS3lpNVZtK2QyOGpFWmRIVGhyOUVGVS9rOGVndWRXelE9PS1NakF5TkRBMU16QT0=',
                language: writingDirection ? 'ar' : 'en',
                wordCount: {
                    displayCharacters: false,
                }
            };

            if (dataLang && dataLang === 'ur_UR') {
                config.toolbar.removeItems = ['fontFamily'];
            }

            return await reloadEditor(config);
        }


        async function startStandardCMSEditingMode() {
            const config = {
                spellCheck: false,
                placeholder: placeholder,
                toolbar: {
                    shouldNotGroupWhenFull: true
                },
                removePlugins: ['RestrictedEditingMode'],
                updateSourceElementOnDestroy: true,
                licenseKey: 'OWIvcXBqSmdzOTkzcnVmdjJMV2k2M2JFR1ovM3czS3lpNVZtK2QyOGpFWmRIVGhyOUVGVS9rOGVndWRXelE9PS1NakF5TkRBMU16QT0=',
                language: writingDirection ? 'ar' : 'en',
                wordCount: {
                    displayCharacters: false,
                }
            };

            if (dataLang && dataLang === 'ur_UR') {
                config.toolbar.removeItems = ['fontFamily'];
            }

            return await reloadEditor(config);
        }

        async function startRestrictedEditingMode() {
            pluginNames.unshift('restrictedEditing');

            const config = {
                placeholder: placeholder,
                removePlugins: ['StandardEditingMode'],
                toolbar: ['restrictedEditing', '|', 'undo', '|', 'redo', 'bold', 'italic', 'link'],
                image: {
                    toolbar: [
                        'imageStyle:inline', 'imageStyle:block', 'imageStyle:wrapText', '|',
                        'toggleImageCaption', 'imageTextAlternative', 'ckboxImageEdit'
                    ]
                },
                updateSourceElementOnDestroy: true,
                licenseKey: 'OWIvcXBqSmdzOTkzcnVmdjJMV2k2M2JFR1ovM3czS3lpNVZtK2QyOGpFWmRIVGhyOUVGVS9rOGVndWRXelE9PS1NakF5TkRBMU16QT0=',
                language: writingDirection ? 'ar' : 'en',
                wordCount: {
                    displayCharacters: false,
                }
            };

            if (dataLang && dataLang === 'ur_UR') {
                config.toolbar.removeItems = ['fontFamily'];
            }

            return await reloadEditor(config);
        }

        const startMode = async (selectedMode) => {
            try {
                console.log("startMode called with:", selectedMode);
                if (scope.isCMS) {
                    editor = await startStandardCMSEditingMode();
                } else if (selectedMode === true) {
                    editor = await startRestrictedEditingMode();
                } else {
                    editor = await startStandardEditingMode();
                }
            } catch (error) {
                console.error('Error in startMode:', error);
            }
        };

        // Initialize editor
        console.log("Initializing editor with restrictedEditingMode:", restrictedEditingMode);

        // Ensure initialization happens in Angular digest cycle
        scope.$applyAsync(() => {
            startMode(restrictedEditingMode).catch(error => {
                console.error('Error initializing editor:', error);
            });
        });
    }
}

// Add static injection array
RichTextEditorNewDirective.$inject = [
    '$rootScope',
    '$injector',
    '$',
    '$window',
    '$bridges',
    '$translate',
    '$config',
    'BridgeRuntimeService',
    'InactivityTimeoutService',
    'IAAPreferencesService',
    'TaskCountdownService',
    '$timeout',
    'dialogs',
    '$signals',
    'TaskSelectionService',
    'TelemetryBeaconService'
];
